import type { FieldControl } from '@platform/core/types';
import type { AnyControl } from './AnyControl';
import { BooleanSwitch } from './controls/BooleanSwitch';
import { ChoicePicker } from './controls/ChoicePicker';
import { DateInput } from './controls/DateInput';
import { FileField } from './controls/FileField';
import { NumberInput } from './controls/NumberInput';
import { RecordLookup } from './controls/RecordLookup';
import { TagInput } from './controls/TagInput';
import { TextArea } from './controls/TextArea';
import { TextInput } from './controls/TextInput';
import { TreePicker } from './controls/TreePicker';
import { UserLookup } from './controls/UserLookup';

const registry = new Map<FieldControl, AnyControl>([
  ['input', TextInput], ['textarea', TextArea], ['number', NumberInput], ['date', DateInput],
  ['picker', ChoicePicker], ['user', UserLookup], ['lookup', RecordLookup], ['tree', TreePicker],
  ['tags', TagInput], ['switch', BooleanSwitch], ['file', FileField], ['json', TextArea],
]);

/** Реєстр контролів за канонічним control; дозволяє підміну/розширення без зміни рушія. */
export function registerFieldControl(control: FieldControl, component: AnyControl): void {
  registry.set(control, component);
}

export function resolveControl(control: FieldControl): AnyControl {
  return registry.get(control) ?? TextInput;
}
